import InstallWebPackageManagers from "../../../../contents/docs/integrate/_snippets/install-web-package-managers.mdx";
import Tab from "components/Tab";
import * as React from 'react';
export default {
  InstallWebPackageManagers,
  Tab,
  React
};